export const langFile = {
  muvelet_sikeresen_vegrehajtva: 'Operation erfolgreich abgeschlossen.',
  nincs_jogosultsagod_a_muvelet_vegrehajtasahoz: 'Sie sind nicht berechtigt, den angeforderten Vorgang durchzuführen.',
  sikeres_torles: 'Erfolgreiche Löschung.',
  hiba_tortent_a_muvelet_vegrehajtasa_soran: 'Bei der Ausführung eines Vorgangs ist ein Fehler aufgetreten.',
  hibas_felhasznalonev_vagy_jelszo: 'Falscher Benutzername oder falsches Passwort!',
  a_jelszonak_minimum_hat_karakternek_kell_lennie: 'Das Passwort muss mindestens 6 Zeichen lang sein.',
  felhasznalonev_megadasa_kotelezo: 'Die Eingabe eines Benutzernamens ist obligatorisch.',
  kotelezoen_kitoltendo_mezo: 'Obligatorisches Feld',
  megbizottak: 'Federführend',
  megbizott: 'Federführend',
  monogram: 'Initialen',
  download_data: 'Daten herunterladen'
}
